// @flow
import React from 'react'
import styled, { css } from 'styled-components'
import { media } from 'src/theme/style-utils'
import { Amex, Visa, MasterCard, Lock } from 'src/components/Icons'
import type { Theme as ThemeType } from 'src/types'

type Props = {
  isWide?: boolean
}

const StyledPaymentOptions = styled.div`
  display: flex;
  justify-content: space-between;
  z-index: 99;
  ${(props: Props) =>
    props.isWide &&
    css`
      ${media.phone`
        width: 100%;
      `}
      ${media.tabletLarge`
        width: auto;
      `}
      ${Secure} {
        ${media.tabletLarge`
          
        `};
      }
    `};
`

const Secure = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  & > :first-child {
    margin-right: 8px;
  }
`

const Options = styled.div`
  align-items: center;
  display: block;
  ${media.desktop`
    display: flex
  `};

  & > * {
    margin-right: 10px;
  }

  & > :last-child {
    margin-right: 0;
  }
`

export const StyledP = styled.div`
  font-family: 'RelativeBook';
  font-size: 14px;
  color: ${(props: { theme: ThemeType }) => props.theme.darkText};
`

export const PaymentOptions = ({ isWide }: Props) => {
  return (
    <StyledPaymentOptions isWide={isWide}>
      <Secure>
        <Lock />
        <StyledP>Secure Payment</StyledP>
      </Secure>
      <Options>
        <Amex />
        <Visa />
        <MasterCard />
      </Options>
    </StyledPaymentOptions>
  )
}



// WEBPACK FOOTER //
// ./src/components/PaymentOptions/index.js